// extracted by mini-css-extract-plugin
export default {"adjusments":"Adjusment_adjusments__0pqDG"};